import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=284a7acd&"
import script from "./Popover.js?vue&type=script&lang=js&"
export * from "./Popover.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports